export const FINAL_STATUS_PENDING = "PENDING";
export const FINAL_STATUS_REJECTED = "REJECTED";
export const FINAL_STATUS_SUCCESS = "SUCCESS";
export const FINAL_STATUS_NEED_REVIEW = "NEED_REVIEW";
export const FINAL_STATUS_NEED_REVIEW_LABEL = "NEED REVIEW";
export const FINAL_STATUS_NEED_REUPLOAD = "NEED_REUPLOAD";
export const FINAL_STATUS_NEED_REUPLOAD_LABEL = "NEED REUPLOAD";

export const FINAL_STATUS_OPTIONS = [
    { value: FINAL_STATUS_PENDING, label: `${FINAL_STATUS_PENDING}` },
    { value: FINAL_STATUS_REJECTED, label: `${FINAL_STATUS_REJECTED}` },
    { value: FINAL_STATUS_SUCCESS, label: `${FINAL_STATUS_SUCCESS}` },
    { value: FINAL_STATUS_NEED_REVIEW, label: `${FINAL_STATUS_NEED_REVIEW_LABEL}` },
    { value: FINAL_STATUS_NEED_REUPLOAD, label: `${FINAL_STATUS_NEED_REUPLOAD_LABEL}` },
];